
/* ========================================
   Shopify Schema 連携 (FAM DS v0.3 / 2026-05-11)
   window.FAMBOX_DIAGNOSIS_DATA から設定取得
   ======================================== */
function getShopifyAssetUrl(type, key) {
  if (!window.FAMBOX_DIAGNOSIS_DATA) return null;
  const assets = window.FAMBOX_DIAGNOSIS_DATA.assets || {};
  return (assets[type] && assets[type][key]) || null;
}

function getShopifyPlanData(planKey) {
  if (!window.FAMBOX_DIAGNOSIS_DATA) return null;
  return (window.FAMBOX_DIAGNOSIS_DATA.plans || {})[planKey] || null;
}

function getShopifyTypeCatchcopy(goalKey) {
  if (!window.FAMBOX_DIAGNOSIS_DATA) return null;
  const types = window.FAMBOX_DIAGNOSIS_DATA.types || {};
  return (types[goalKey] && types[goalKey].catchcopy) || null;
}
/**
 * FAM BOX アスリート向け食事診断 v2
 * 改修: 目的ベースロジック + FAMプラン直結型
 */
'use strict';

/* ========================================
   質問データ（全12問・順序変更）
   ======================================== */
const QUESTIONS = [
  /* Q2: 性別・年代（最初に基本情報） */
  {
    id: 'q2', step: 1, type: 'gender-age',
    title: '性別と年代を教えてください',
    sub: '性別によって推奨される栄養バランスが異なります',
    stepIntro: { label: 'STEP 1 of 5', heading: '基本プロフィール', desc: 'あなたの性別・年齢・体格について教えてください。基本情報をもとに栄養戦略の土台を作ります。' },
    genderOptions: [
      { value: 'male', label: '男性', icon: '\u2642\uFE0F' },
      { value: 'female', label: '女性', icon: '\u2640\uFE0F' }
    ],
    ageOptions: [
      { value: '15-18', label: '15\u301C18歳（中高生）' },
      { value: '19-22', label: '19\u301C22歳（大学生）' },
      { value: '23-29', label: '23\u301C29歳' },
      { value: '30-39', label: '30\u301C39歳' },
      { value: '40+', label: '40歳以上' }
    ]
  },
  /* Q3: 体格情報 */
  {
    id: 'q3', step: 1, type: 'weight-select',
    title: '体格情報を教えてください',
    sub: '現在の体重を教えてください（おおよそで構いません）',
    weightMin: 40, weightMax: 120, weightDefault: 65,
    weightFeelLabel: '現在の体重について、どのように感じていますか？',
    weightFeelOptions: [
      { value: 'gain_much', label: 'もっと増やしたい（+5kg以上）' },
      { value: 'gain_little', label: '少し増やしたい（+1\u301C4kg）' },
      { value: 'maintain', label: '今のままでよい' },
      { value: 'lose_little', label: '少し減らしたい（\u22121\u301C4kg）' },
      { value: 'lose_much', label: 'もっと減らしたい（\u22125kg以上）' }
    ]
  },
  /* Q1: 競技カテゴリ（参考情報として収集、スコア加点なし） */
  {
    id: 'q1', step: 2, type: 'card-single',
    title: 'あなたの競技カテゴリを教えてください',
    sub: '参考情報としてお聞きします（結果には大きく影響しません）',
    stepIntro: { label: 'STEP 2 of 5', heading: '競技情報', desc: '参考情報として競技を教えてください。' },
    options: [
      { value: 'goal', label: '球技系（ゴール型）', desc: 'サッカー、ラグビー、バスケ、ハンド等', icon: '\u26BD' },
      { value: 'net', label: '球技系（ネット型・的当て型）', desc: 'バレー、テニス、バドミントン、卓球等', icon: '\uD83C\uDFD0' },
      { value: 'baseball', label: '球技系（ベースボール型）', desc: '野球、ソフトボール', icon: '\u26BE' },
      { value: 'endurance', label: '持久系', desc: '陸上長距離、マラソン、トライアスロン、自転車等', icon: '\uD83C\uDFC3' },
      { value: 'sprint', label: '瞬発系・スプリント系', desc: '陸上短距離、跳躍、投擲', icon: '\u26A1' },
      { value: 'weight', label: 'ウェイト系・格闘系', desc: '柔道、レスリング、ウェイトリフティング等', icon: '\uD83E\uDD4A' },
      { value: 'aesthetic', label: '審美系', desc: '体操、新体操、フィギュア、チア等', icon: '\uD83E\uDD38' },
      { value: 'swimming', label: '水泳・水中スポーツ', desc: '競泳、水球、飛込み', icon: '\uD83C\uDFCA' },
      { value: 'other', label: 'その他', desc: '上記に当てはまらない競技', icon: '\uD83C\uDFC5' }
    ]
  },
  /* Q_GOAL: 目標（上位概念） — 新設 */
  {
    id: 'q_goal', step: 3, type: 'card-single',
    title: '食事で達成したい目標は何ですか？',
    sub: '最も近いものを1つ選んでください',
    stepIntro: { label: 'STEP 3 of 5', heading: '目的設定', desc: 'あなたの目的を教えてください。目的に合わせた最適なプランを導き出します。' },
    cssModifier: 'quiz__cards--large',
    options: [
      { value: 'muscle_gain', label: '筋肉量で体重を増やしたい', desc: '筋肉量を増やして体重を増やしたい', icon: '\uD83D\uDCAA' },
      { value: 'bulk_up', label: '体を大きくしたい', desc: '体脂肪増も含めてとにかく体重を増やしたい', icon: '\u2B06' },
      { value: 'lean_down', label: '筋肉量を維持しながら体脂肪を落としたい', desc: '減量・除脂肪', icon: '\u2B07' },
      { value: 'maintain', label: '体調・コンディションを維持したい', desc: '健康維持・パフォーマンス維持', icon: '\uD83D\uDEE1' }
    ]
  },
  /* Q11: 身体の気になる症状（悩み系・整理済み） */
  {
    id: 'q11', step: 3, type: 'grid-multi',
    title: '体の気になる症状があれば教えてください',
    sub: '最大3つまで選べます',
    maxSelect: 3,
    allowZero: true,
    options: [
      { value: 'fatigue', label: '日々の疲れが気になる', icon: '\uD83D\uDE29' },
      { value: 'anemia', label: 'ふらつき・疲れやすさを感じる', icon: '\uD83E\uDE78' },
      { value: 'cold', label: '体調を崩しやすい', icon: '\uD83E\uDD27' },
      { value: 'injury', label: 'スポーツでのケガが気になる', icon: '\uD83E\uDE7C' },
      { value: 'cramp', label: '足のつりが気になる', icon: '\uD83E\uDDB6' },
      { value: 'stamina', label: 'スタミナ・持久力を高めたい', icon: '\uD83C\uDFC3' }
    ],
    noneOption: { value: 'none', label: '特に悩みはない', icon: '\u2714' }
  },
  /* Q5: 活動レベル（アスリート/一般の判定兼トレーニング強度） */
  {
    id: 'q5', step: 4, type: 'list-single',
    title: 'あなたの運動・競技活動のレベルを教えてください',
    sub: '最も近いものを1つ選んでください（プラン判定の主軸となる質問です）',
    stepIntro: { label: 'STEP 4 of 5', heading: '活動レベル', desc: 'あなたの現在の活動状況を教えてください。プランの判定に影響する重要な質問です。' },
    options: [
      { value: 'pro', label: 'プロ契約・実業団／企業スポーツ所属', sub: 'トップアスリート' },
      { value: 'club', label: '部活・クラブチーム所属で大会出場（週4回以上の練習）', sub: '競技者' },
      { value: 'amateur_compete', label: '週3回以上のトレーニング＋大会出場の予定あり', sub: '競技志向' },
      { value: 'casual', label: '週1〜2回の運動習慣（大会出場なし／健康目的）', sub: '一般' },
      { value: 'none', label: '運動習慣は特になし／健康維持が目的', sub: '一般' }
    ]
  },
  /* Q6: 練習時間 */
  {
    id: 'q6', step: 4, type: 'list-single',
    title: '1日の練習時間はどのくらいですか？',
    sub: 'ウォーミングアップ・クールダウンを含めた合計時間',
    options: [
      { value: 'under1', label: '1時間未満' },
      { value: '1to2', label: '1\u301C2時間' },
      { value: '2to3', label: '2\u301C3時間' },
      { value: 'over3', label: '3時間以上' }
    ]
  },
  /* Q7-Q10: 食生活チェック削除 (FAM DS v0.3 / 2026-05-08) - diagnosis-old.js 参照 */
  /* Q15: 改善意欲度（条件分岐） */
  {
    id: 'q15', step: 5, type: 'list-single',
    title: '食事の改善にどのくらい取り組めそうですか？',
    sub: '無理のないペースで始めることが大切です',
    conditional: true,
    options: [
      { value: 'full', label: 'しっかり取り組みたい', sub: '自炊含め食事全体を見直したい' },
      { value: 'moderate', label: 'できる範囲で改善したい', sub: 'まずは1つ2つから始めたい' },
      { value: 'easy', label: '手軽に始めたい', sub: 'FAM BOXなどの宅配食を活用したい' }
    ]
  }
];

/* ========================================
   結果タイプ定義（FAMプラン直結型）
   ======================================== */

/**
 * 結果タイプ:
 *  - muscle_gain: 筋肉量増加型 → アスリートプラス60（体重1kgあたり2.5g以上）
 *  - athlete_standard: アスリート標準型 → アスリートサポート50（体重1kgあたり2g）
 *  - health_maintain: 健康維持型 → フィジカルプラン40
 *  - lean_support: 減量サポート型 → 体重1kgあたり2g目安
 *  - general_healthcare: 一般ヘルスケア → ヘルスケアプラン30
 */

const RESULT_DATA = {
  /* --- 筋肉量増加型（アスリートプラス60） --- */
  'muscle_gain_max': {
    patternName: '筋肉量増加・ラージ', goalKey: 'muscle_gain', goalName: '筋肉量増加型',
    planKey: 'athleteplus60', planName: 'アスリートプラス60', planProtein: 60,
    catchcopy: '最大級のパワーを支える、圧倒的な食事量',
    goalDesc: '筋肉量の増加を最優先にした栄養戦略です。体重1kgあたり2.5g以上のたんぱく質を目標に、十分なエネルギーと栄養素を確保します。',
    pfc: { p: [18, 20], f: [25, 28], c: [52, 55] }, refWeight: 85, kcal: 4200, pGrams: 180,
    tips: [
      { title: '1日5〜6食で必要カロリーを確保する', text: '4000kcal超を3食で摂ると胃腸に負担がかかります。こまめな補食で分散しましょう。' },
      { title: 'たんぱく質を毎食しっかり摂る', text: '体重1kgあたり2.5gのたんぱく質を目標に、3食＋補食で分散して摂取。肉・魚・卵・大豆製品を毎食のおかずに必ず含めましょう。' },
      { title: '主食の量を意識的に増やす', text: '大きな身体を維持・拡大するには炭水化物が不可欠。ごはんは毎食300g（約500kcal）以上を目安にしましょう。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん特盛り、鮭の塩焼き、目玉焼き2個、納豆、ほうれん草おひたし、味噌汁（豚汁）、牛乳、バナナ', fambox: false },
      { time: '補食 10:00（練習前）', icon: '\u26A1', menu: 'おにぎり2個、バナナ、カステラ', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（アスリートプラス60g）＋ごはん特盛り＋サラダ＋ヨーグルト＋みかん', fambox: true, famboxLabel: 'FAM BOX アスリートプラス 60g' },
      { time: '補食 16:00（練習後30分以内）', icon: '\u26A1', menu: 'おにぎり2個、プロテインドリンク（牛乳ベース）、キウイ', fambox: false },
      { time: '夕食 19:30', icon: '\uD83C\uDF19', menu: 'ごはん特盛り、ステーキ200g、温野菜（ブロッコリー・にんじん）、豆腐の味噌汁、チーズ、りんご', fambox: false },
      { time: '就寝前補食 22:00', icon: '\u26A1', menu: 'ホットミルク、プロテイン、小さめおにぎり1個', fambox: false }
    ]
  },
  'muscle_gain_standard': {
    patternName: '筋肉量増加・スタンダード', goalKey: 'muscle_gain', goalName: '筋肉量増加型',
    planKey: 'athleteplus60', planName: 'アスリートプラス60', planProtein: 60,
    catchcopy: '力強い身体を作る、攻めの食事戦略',
    goalDesc: '筋肉量の増加を最優先にした栄養戦略です。体重1kgあたり2.5g以上のたんぱく質を目標に、十分なエネルギーと栄養素を確保します。',
    pfc: { p: [18, 20], f: [25, 28], c: [52, 55] }, refWeight: 70, kcal: 3500, pGrams: 150,
    tips: [
      { title: 'たんぱく質を毎食しっかり摂る', text: '体重1kgあたり2.5gのたんぱく質を目標に、3食＋補食で分散して摂取。肉・魚・卵・大豆製品を毎食のおかずに必ず含めましょう。' },
      { title: '十分な炭水化物でエネルギーを確保する', text: '高たんぱく質食では炭水化物が不足しがち。55%以上の炭水化物エネルギー比を維持し、筋たんぱく質の分解を防ぎましょう。' },
      { title: '食事回数を増やしてエネルギー確保', text: '3食だけで必要カロリーを摂るのは難しいため、補食を1〜2回追加して1日4〜5食体制に。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん大盛り、鮭の塩焼き、卵焼き、納豆、サラダ、味噌汁、牛乳、キウイ', fambox: false },
      { time: '補食 10:00（練習前）', icon: '\u26A1', menu: 'おにぎり1個、プロテインバー、バナナ', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（アスリートプラス60g）＋ごはん大盛り＋野菜スープ＋ヨーグルト＋オレンジ', fambox: true, famboxLabel: 'FAM BOX アスリートプラス 60g' },
      { time: '補食 16:00（練習後30分以内）', icon: '\u26A1', menu: 'あんぱん、バナナ、プロテインドリンク（牛乳ベース）', fambox: false },
      { time: '夕食 19:30', icon: '\uD83C\uDF19', menu: 'ごはん大盛り、豚しょうが焼き（大盛り）、ほうれん草おひたし、豆腐の味噌汁、ヨーグルト、オレンジ', fambox: false }
    ]
  },

  /* --- アスリート標準型（アスリートサポート50） --- */
  'athlete_standard_large': {
    patternName: 'アスリート標準・ラージ', goalKey: 'athlete_standard', goalName: 'アスリート標準型',
    planKey: 'athletesupport50', planName: 'アスリートサポート50', planProtein: 50,
    catchcopy: '筋力アップとコンディション維持の両立',
    goalDesc: '筋力アップとコンディション維持を両立する栄養戦略です。体重1kgあたり2gのたんぱく質を確保しながら、バランスの取れた食事を心がけます。',
    pfc: { p: [17, 19], f: [25, 28], c: [53, 56] }, refWeight: 75, kcal: 3400, pGrams: 150,
    tips: [
      { title: '高い運動量を支えるエネルギー確保', text: '大柄な選手は消費カロリーが大きい。主食の量を意識的に多くし、補食も取り入れましょう。' },
      { title: '毎食の「おかず」を充実させる', text: '肉・魚・卵・大豆製品を毎食1〜2品。多様なたんぱく質源でアミノ酸バランスを整えましょう。' },
      { title: '鉄分を意識する', text: '体重が大きく運動量も多い場合、鉄の需要が増加。赤身肉・レバー・小松菜をビタミンCと一緒に摂りましょう。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん大盛り、ハムエッグ、サラダ、味噌汁（豚汁）、牛乳、バナナ', fambox: false },
      { time: '補食 10:00（練習前）', icon: '\u26A1', menu: 'おにぎり1個、チーズ、バナナ', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（アスリートサポート50g）＋ごはん大盛り＋野菜スープ＋ヨーグルト＋みかん', fambox: true, famboxLabel: 'FAM BOX アスリートサポート 50g' },
      { time: '補食 16:00（練習後30分以内）', icon: '\u26A1', menu: 'あんパン、プロテインドリンク（牛乳ベース）、キウイ', fambox: false },
      { time: '夕食 19:30', icon: '\uD83C\uDF19', menu: 'ごはん大盛り、レバニラ炒め、冷ややっこ、わかめ味噌汁、チーズ、オレンジ', fambox: false }
    ]
  },
  'athlete_standard_medium': {
    patternName: 'アスリート標準・ミドル', goalKey: 'athlete_standard', goalName: 'アスリート標準型',
    planKey: 'athletesupport50', planName: 'アスリートサポート50', planProtein: 50,
    catchcopy: '速く強く動ける身体を、食事で磨く',
    goalDesc: '筋力アップとコンディション維持を両立する栄養戦略です。体重1kgあたり2gのたんぱく質を確保しながら、バランスの取れた食事を心がけます。',
    pfc: { p: [17, 19], f: [25, 30], c: [53, 56] }, refWeight: 65, kcal: 2900, pGrams: 130,
    tips: [
      { title: '毎食の「おかず」を充実させる', text: '肉・魚・卵・大豆製品を毎食1〜2品。多様なたんぱく質源でアミノ酸バランスを整えましょう。' },
      { title: '練習前後の食事タイミングを意識する', text: '競技開始3〜4時間前に高炭水化物の食事、練習後30分以内に炭水化物＋たんぱく質の補食を。' },
      { title: '水分補給を日常から習慣にする', text: '体重の2%の脱水でパフォーマンスが低下します。日常的に1日2L以上の水分摂取を心がけましょう。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん、焼き鮭、納豆、味噌汁（豆腐・わかめ）、サラダ、ヨーグルト、みかん', fambox: false },
      { time: '補食 10:00（練習前）', icon: '\u26A1', menu: 'おにぎり1個、バナナ', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（アスリートサポート50g）＋ごはん＋サラダ＋牛乳＋キウイ', fambox: true, famboxLabel: 'FAM BOX アスリートサポート 50g' },
      { time: '補食 16:00（練習後30分以内）', icon: '\u26A1', menu: 'おにぎり1個、プロテインドリンク（牛乳ベース）、みかん', fambox: false },
      { time: '夕食 19:30', icon: '\uD83C\uDF19', menu: 'ごはん、鶏の照り焼き、小松菜のおひたし、野菜たっぷり味噌汁、ヨーグルト、キウイ', fambox: false }
    ]
  },

  /* --- 健康維持型（フィジカルプラン40） --- */
  'health_maintain_standard': {
    patternName: '健康維持・スタンダード', goalKey: 'health_maintain', goalName: '健康維持型',
    planKey: 'physical40', planName: 'フィジカルプラン40', planProtein: 40,
    catchcopy: 'コンディションを土台に、次のステップへ',
    goalDesc: '体調管理と回復を優先する栄養戦略です。栄養フルコース5要素を毎日欠かさず揃えることが最も大切です。',
    pfc: { p: [16, 18], f: [25, 30], c: [55, 58] }, refWeight: 60, kcal: 2500, pGrams: 100,
    tips: [
      { title: '栄養フルコース5要素を毎日揃える', text: 'コンディション維持に最も重要なのは「バランス」。5要素を毎食チェックしましょう。' },
      { title: '規則正しい食事リズムを確立する', text: '朝食を含む1日3食＋補食の規則的な食事が、体内時計の正常化とコンディション維持の基盤です。' },
      { title: '腸内環境を整える食事を取り入れる', text: '発酵食品（ヨーグルト・納豆・味噌）、食物繊維（野菜・きのこ・海藻）を毎日摂取しましょう。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん、味噌汁（わかめ・なめこ）、焼き鮭、納豆、ほうれん草おひたし、ヨーグルト、みかん', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（フィジカルプラン40g）＋ごはん＋野菜たっぷりスープ＋牛乳＋オレンジ', fambox: true, famboxLabel: 'FAM BOX フィジカルプラン 40g' },
      { time: '補食 15:00', icon: '\u26A1', menu: 'おにぎり1個、バナナ', fambox: false },
      { time: '夕食 19:00', icon: '\uD83C\uDF19', menu: 'ごはん、鶏むね肉の蒸し焼き、ブロッコリーのサラダ、味噌汁、チーズ、キウイ', fambox: false }
    ]
  },
  'health_maintain_large': {
    patternName: '健康維持・ラージ', goalKey: 'health_maintain', goalName: '健康維持型',
    planKey: 'physical40', planName: 'フィジカルプラン40', planProtein: 40,
    catchcopy: '大きな身体のメンテナンス、質の高い食事で支える',
    goalDesc: '体調管理と回復を優先する栄養戦略です。栄養フルコース5要素を毎日欠かさず揃えることが最も大切です。',
    pfc: { p: [16, 18], f: [25, 28], c: [55, 58] }, refWeight: 72, kcal: 3100, pGrams: 130,
    tips: [
      { title: 'オフ期の体脂肪増加を食事でコントロール', text: '練習量が減る時期は主食を10〜15%減らし、おかず・野菜・果物・乳製品の比率を高めましょう。' },
      { title: 'リカバリーに役立つ食材を意識する', text: 'オメガ3脂肪酸（青魚）、ポリフェノール（ブルーベリー）、ビタミンE（ナッツ）はコンディション維持の食材としておすすめです。' },
      { title: '栄養フルコース5要素を毎日揃える', text: 'コンディション維持に最も重要なのは「バランス」。5要素を毎食チェックしましょう。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん、味噌汁（豆腐・ほうれん草）、卵焼き、サラダ、ヨーグルト、ブルーベリー', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（フィジカルプラン40g）＋ごはん＋温野菜＋牛乳＋みかん', fambox: true, famboxLabel: 'FAM BOX フィジカルプラン 40g' },
      { time: '補食 15:30', icon: '\u26A1', menu: 'ナッツ、バナナ、チーズ', fambox: false },
      { time: '夕食 19:00', icon: '\uD83C\uDF19', menu: 'ごはん、鯖の味噌煮、きんぴらごぼう、ひじきの煮物、味噌汁、ヨーグルト、キウイ', fambox: false }
    ]
  },

  /* --- 減量サポート型（アスリートサポート50ベース） --- */
  'lean_support_standard': {
    patternName: '減量サポート・スタンダード', goalKey: 'lean_support', goalName: '減量サポート型',
    planKey: 'athletesupport50', planName: 'アスリートサポート50', planProtein: 50,
    catchcopy: '筋肉を守りながら、賢く絞る食事戦略',
    goalDesc: '筋肉量を維持しながら体脂肪を落とす栄養戦略です。たんぱく質を体重1kgあたり2g以上確保しつつ、エネルギーバランスを調整します。',
    pfc: { p: [20, 22], f: [22, 25], c: [53, 58] }, refWeight: 65, kcal: 2500, pGrams: 130,
    tips: [
      { title: 'たんぱく質は維持、炭水化物で調整', text: '減量中でもたんぱく質は体重1kgあたり2g以上を維持しましょう。エネルギーカットは炭水化物を10〜15%減らすことで行います。' },
      { title: '調理法の工夫でカロリーカット', text: '揚げ物→焼き・蒸し・茹でに変えるだけで1食あたり100〜200kcalカットできます。食材はそのままに、調理法を変えることが無理のない減量のコツです。' },
      { title: '欠食は逆効果です', text: '食事を抜くと空腹感から次の食事で過食しやすく、筋肉の分解も進みます。1日3食＋適切な補食を維持しましょう。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん（普通盛り）、焼き魚（鮭）、ほうれん草おひたし、味噌汁、ヨーグルト、キウイ', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（アスリートサポート50g）＋ごはん（普通盛り）＋サラダ＋牛乳＋オレンジ', fambox: true, famboxLabel: 'FAM BOX アスリートサポート 50g' },
      { time: '補食 15:30', icon: '\u26A1', menu: 'バナナ、プロテインドリンク（牛乳ベース）', fambox: false },
      { time: '夕食 19:00', icon: '\uD83C\uDF19', menu: 'ごはん（少なめ）、鶏むね肉の蒸し焼き、温野菜サラダ、味噌汁、チーズ少量、みかん', fambox: false }
    ]
  },
  'lean_support_light': {
    patternName: '減量サポート・ライト', goalKey: 'lean_support', goalName: '減量サポート型',
    planKey: 'physical40', planName: 'フィジカルプラン40', planProtein: 40,
    catchcopy: '無理なく絞る、バランス重視の減量',
    goalDesc: '筋肉量を維持しながら体脂肪を落とす栄養戦略です。たんぱく質を確保しつつ、エネルギーバランスを調整します。',
    pfc: { p: [18, 20], f: [22, 25], c: [55, 60] }, refWeight: 55, kcal: 2100, pGrams: 100,
    tips: [
      { title: 'たんぱく質は維持、炭水化物で調整', text: '減量中でもたんぱく質は体重1kgあたり2g以上を維持しましょう。' },
      { title: '野菜のかさ増しで満足感をアップ', text: '野菜料理を毎食2品以上取り入れると、カロリーを抑えながら満足感が得られます。' },
      { title: '欠食は逆効果です', text: '食事を抜くと空腹感から次の食事で過食しやすく、筋肉の分解も進みます。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん（少なめ）、味噌汁（豆腐・小松菜）、卵焼き、サラダ、ヨーグルト、キウイ', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（フィジカルプラン40g）＋ごはん＋ミニサラダ＋牛乳＋みかん', fambox: true, famboxLabel: 'FAM BOX フィジカルプラン 40g' },
      { time: '補食 15:30', icon: '\u26A1', menu: 'バナナ、チーズ少量', fambox: false },
      { time: '夕食 19:00', icon: '\uD83C\uDF19', menu: 'ごはん（少なめ）、焼き魚（鮭）、温野菜サラダ、ひじきの煮物、味噌汁、ヨーグルト、みかん', fambox: false }
    ]
  },

  /* --- 一般ヘルスケア（ヘルスケアプラン30） --- */
  'general_healthcare': {
    patternName: 'ヘルスケア', goalKey: 'general_healthcare', goalName: '一般ヘルスケア型',
    planKey: 'healthcare30', planName: 'ヘルスケアプラン30', planProtein: 30,
    catchcopy: '健康の土台を整える、基本の食事習慣',
    goalDesc: '健康維持を目的とした栄養戦略です。無理なく栄養バランスを整え、日常の食事の質を高めます。',
    pfc: { p: [16, 18], f: [25, 30], c: [55, 58] }, refWeight: 50, kcal: 1900, pGrams: 75,
    tips: [
      { title: '栄養フルコース5要素を毎日揃える', text: '主食・おかず・野菜・果物・乳製品の5要素を毎食チェックしましょう。' },
      { title: '鉄・カルシウム・ビタミンDを強化する', text: '赤身肉・レバーで鉄を、乳製品・小魚でカルシウムを、魚・きのこ類でビタミンDを摂取しましょう。' },
      { title: '過度な食事制限を避ける', text: '極端なカロリー制限はコンディション悪化の原因になります。バランスよく食べることが大切です。' }
    ],
    meals: [
      { time: '朝食 7:00', icon: '\u2600', menu: 'ごはん、味噌汁（豆腐・小松菜）、卵焼き、ほうれん草おひたし、ヨーグルト、キウイ', fambox: false },
      { time: '昼食 12:30', icon: '\uD83C\uDF71', menu: 'FAM BOX（ヘルスケアプラン30g）＋ごはん＋ミニサラダ＋牛乳＋みかん', fambox: true, famboxLabel: 'FAM BOX ヘルスケアプラン 30g' },
      { time: '補食 15:00', icon: '\u26A1', menu: 'バナナ、チーズ少量', fambox: false },
      { time: '夕食 19:00', icon: '\uD83C\uDF19', menu: 'ごはん、焼き魚（鮭）、温野菜サラダ、ひじきの煮物、味噌汁、ヨーグルト、みかん', fambox: false }
    ]
  }
};

/* タイプ別アイコン・カラー対応表（新: 目的ベース） */
const TYPE_META = {
  muscle_gain:        { icon: '\uD83D\uDCAA', color: '#C0392B', label: '筋肉量増加型' },
  athlete_standard:   { icon: '\u26A1',        color: '#2980B9', label: 'アスリート標準型' },
  health_maintain:    { icon: '\uD83D\uDEE1', color: '#27AE60', label: '健康維持型' },
  lean_support:       { icon: '\uD83C\uDFC3', color: '#E67E22', label: '減量サポート型' },
  general_healthcare: { icon: '\u2764',        color: '#8E44AD', label: '一般ヘルスケア型' }
};

/* ========================================
   アプリケーション状態管理
   ======================================== */
const state = {
  currentQuestion: 0,
  answers: {},
  totalQuestions: 12,
  skipQ15: false,
  pfcChart: null,
  mode: 'both',
  currentCategory: 'A',
  categoryADone: false
};

/* ========================================
   スコアリングロジック（v2: 目的ベース）
   ======================================== */

/**
 * v3ロジック: FAMプラン定義に基づくマトリクス駆動
 * 体重クラス(<50/50-70/≥70) × 目的(筋肉UP/維持/健康) × 属性(アスリート/一般) → プラン直結
 *
 * プラン定義（参照元）:
 *   アスリートプラス60: 重量級≥70kg × 筋肉量UP × アスリート
 *   アスリートサポート50: 中量級50-70 × 筋肉量UP × アスリート / 重量級 × 維持 × アスリート / 重量級 × 筋肉量UP × 一般
 *   フィジカルプラン40: 軽量級<50 × 筋肉量UP × アスリート / 中量級 × 維持 × アスリート / 中量級 × 筋肉量UP × 一般
 *   ヘルスケアプラン30: 軽量級 × 維持 × アスリート / 軽量級 × 筋肉量UP × 一般 / 健康維持 × 一般
 *
 * 競技カテゴリ(q1)はスコアに影響しない（参考情報）
 */
function calculateResult() {
  const goal = state.answers.q_goal;      // muscle_gain | bulk_up | lean_down | maintain
  const weight = state.answers.q3_weight || 65;
  const q3feel = state.answers.q3_feel;
  const q11 = state.answers.q11 || [];

  const audience = determineAudience();       // 'athlete' | 'general'
  const goalType = determineGoalType(goal, audience); // 'muscle_up' | 'maintain' | 'health' | 'lean_down'
  const weightClass = weight < 50 ? 'light' : weight < 70 ? 'medium' : 'heavy';
  const intensity = calculateTrainingIntensity();

  let resultKey;

  // 減量(lean_down)は専用のプラン内容（メニュー/Tipsが異なる）を使いつつ、プラン容量は体重で決定
  if (goalType === 'lean_down') {
    resultKey = weightClass === 'light' ? 'lean_support_light' : 'lean_support_standard';
  } else {
    // マトリクス: weightClass-goalType-audience → resultKey
    const matrixKey = `${weightClass}-${goalType}-${audience}`;
    const MATRIX = {
      // 重量級(≥70kg)
      'heavy-muscle_up-athlete':  'muscle_gain_max',        // アスリートプラス60
      'heavy-muscle_up-general':  'athlete_standard_large', // アスリートサポート50
      'heavy-maintain-athlete':   'athlete_standard_large', // アスリートサポート50
      'heavy-maintain-general':   'health_maintain_large',  // フィジカルプラン40
      'heavy-health-general':     'health_maintain_large',  // フィジカルプラン40
      // 中量級(50-70kg)
      'medium-muscle_up-athlete': 'athlete_standard_medium',// アスリートサポート50
      'medium-muscle_up-general': 'health_maintain_standard',// フィジカルプラン40
      'medium-maintain-athlete':  'health_maintain_standard',// フィジカルプラン40
      'medium-maintain-general':  'general_healthcare',     // ヘルスケアプラン30
      'medium-health-general':    'general_healthcare',     // ヘルスケアプラン30
      // 軽量級(<50kg)
      'light-muscle_up-athlete':  'health_maintain_standard',// フィジカルプラン40
      'light-muscle_up-general':  'general_healthcare',     // ヘルスケアプラン30
      'light-maintain-athlete':   'general_healthcare',     // ヘルスケアプラン30
      'light-maintain-general':   'general_healthcare',     // ヘルスケアプラン30
      'light-health-general':     'general_healthcare'      // ヘルスケアプラン30
    };
    resultKey = MATRIX[matrixKey] || 'general_healthcare';
  }

  // 重量級×筋肉量UP×アスリート で練習時間が長い(over3)場合は max を明示（大柄アスリート向け）
  if (resultKey === 'muscle_gain_max' && weight < 80 && intensity !== 'high') {
    resultKey = 'muscle_gain_standard';
  }

  // conditioning修飾子の収集
  const condFlags = ['fatigue', 'anemia', 'injury', 'cold', 'cramp'];
  state.conditioningFlags = q11.filter(v => condFlags.includes(v));

  // 体重目標フラグの収集
  if (q3feel === 'lose_little' || q3feel === 'lose_much') {
    state.weightGoalFlag = 'lose';
  } else if (q3feel === 'gain_much' || q3feel === 'gain_little') {
    state.weightGoalFlag = 'gain';
  } else {
    state.weightGoalFlag = null;
  }

  // 属性情報をstateに保持（結果画面で「あなたは◯◯向け」表示用）
  state.audience = audience;
  state.goalType = goalType;
  state.weightClass = weightClass;

  console.log('[Scoring v3]', { goal, goalType, weight, weightClass, audience, intensity, resultKey, condFlags: state.conditioningFlags, weightGoal: state.weightGoalFlag });

  return RESULT_DATA[resultKey] || RESULT_DATA['general_healthcare'];
}

/**
 * 属性判定: アスリート / 一般
 * Q5の活動レベルのみで判定（プロ・部活・週3大会出場 → アスリート、週1-2・なし → 一般）
 */
function determineAudience() {
  const q5 = state.answers.q5;
  if (q5 === 'pro' || q5 === 'club' || q5 === 'amateur_compete') return 'athlete';
  return 'general'; // casual, none, または未回答
}

/**
 * 目的タイプ判定: 筋肉量UP / 維持 / 健康維持 / 減量
 * q_goalとaudienceの組み合わせで決定
 *   muscle_gain, bulk_up → muscle_up
 *   lean_down → lean_down（専用ルート）
 *   maintain × アスリート → maintain
 *   maintain × 一般 → health（健康維持プラン）
 */
function determineGoalType(goal, audience) {
  if (goal === 'muscle_gain' || goal === 'bulk_up') return 'muscle_up';
  if (goal === 'lean_down') return 'lean_down';
  if (goal === 'maintain') return audience === 'athlete' ? 'maintain' : 'health';
  return 'health'; // fallback
}

/**
 * トレーニング強度を算出（Q5活動レベル × Q6練習時間）
 */
function calculateTrainingIntensity() {
  const levelScore = { pro: 4, club: 4, amateur_compete: 3, casual: 1, none: 0 };
  const durScore   = { under1: 1, '1to2': 2, '2to3': 3, over3: 4 };
  const lv  = levelScore[state.answers.q5] !== undefined ? levelScore[state.answers.q5] : 2;
  const dur = durScore[state.answers.q6] !== undefined ? durScore[state.answers.q6] : 2;
  const raw = lv * dur;
  if (raw <= 3) return 'low';
  if (raw <= 9) return 'moderate';
  return 'high';
}

/**
 * たんぱく質の体重あたり必要量を算出
 */
function calculateProteinPerKg() {
  const goal = state.answers.q_goal;
  const q3feel = state.answers.q3_feel;

  // 筋肉量増加・体を大きくする → 2.5g/kg
  if (goal === 'muscle_gain' || goal === 'bulk_up') return 2.5;
  // 増量希望 → 2.5g/kg
  if (q3feel === 'gain_much' || q3feel === 'gain_little') return 2.5;
  // その他 → 2.0g/kg
  return 2.0;
}

/* ========================================
   コンディショニング修飾子
   ======================================== */
const CONDITIONING_MODIFIERS = {
  injury: {
    title: '怪我回復中の栄養戦略',
    text: 'たんぱく質は体重1kgあたり2g以上を維持しましょう。ビタミンC（果物・野菜）と亜鉛（牡蠣・牛肉）で組織の修復を支援。活動量が減っている場合は炭水化物を調整してエネルギーバランスを取りましょう。',
    icon: '\uD83E\uDE7C'
  },
  anemia: {
    title: '鉄分を意識した食事ポイント',
    text: '赤身肉・レバー（ヘム鉄）にビタミンCを組み合わせて摂取するのがおすすめ。食事の前後30分はお茶・コーヒーを控えめに（タンニンが鉄分の吸収を妨げます）。鉄分の目安は1日20〜25mgです。',
    icon: '\uD83E\uDE78'
  },
  fatigue: {
    title: '疲れにくい体づくりを意識した食事',
    text: 'ビタミンB群（豚肉・玄米・卵・大豆製品）と鉄分を意識的に摂取。練習後30分以内の炭水化物＋たんぱく質補給で筋グリコーゲン補充をサポートしましょう。',
    icon: '\uD83D\uDE29'
  },
  cold: {
    title: '日々の体調を整える食事',
    text: 'ビタミンA（にんじん・ほうれん草）・C（キウイ・ブロッコリー）・E（ナッツ・アボカド）と亜鉛を毎食意識。発酵食品で腸内環境を整えることもコンディション維持の基盤です。',
    icon: '\uD83E\uDD27'
  },
  cramp: {
    title: 'ミネラルバランスを意識した栄養素',
    text: 'マグネシウム（ナッツ・海藻・大豆）、カリウム（バナナ・芋類・ほうれん草）、カルシウム（乳製品・小魚）をバランスよく摂取。',
    icon: '\uD83E\uDDB6'
  }
};

const WEIGHT_GOAL_MODIFIERS = {
  lose: [
    { title: 'たんぱく質は維持、炭水化物で調整', text: '減量中でもたんぱく質は体重1kgあたり2g以上を維持しましょう。エネルギーカットは炭水化物を10〜15%減らすことで行います。', icon: '\u{1F4C9}' },
    { title: '調理法の工夫でカロリーカット', text: '揚げ物→焼き・蒸し・茹でに変えるだけで1食あたり100〜200kcalカットできます。', icon: '\uD83C\uDF73' },
    { title: '欠食は逆効果です', text: '食事を抜くと空腹感から次の食事で過食しやすく、筋肉の分解も進みます。1日3食＋適切な補食を維持しましょう。', icon: '\u26A0\uFE0F' }
  ],
  gain: [
    { title: '食事回数を増やしてエネルギー確保', text: '3食だけで必要カロリーを摂るのは難しいため、補食を1〜2回追加して1日4〜5食体制に。', icon: '\u{1F4C8}' },
    { title: '主食の量を意識的に増やす', text: 'ごはんを毎食50g（約80kcal）増やすだけで、1日で約240kcalのアップ。「食べることもトレーニング」です。', icon: '\uD83C\uDF5A' }
  ]
};

/* ========================================
   UI描画関数
   ======================================== */

/** Q15を表示するかどうかの判定（食生活チェック廃止に伴い常に表示） */
function shouldShowQ15() {
  return true;
}

/* 質問IDリスト（食生活チェック削除後の8問構成 / 2026-05-08） */
const CATEGORY_A_IDS = ['q2', 'q3', 'q1', 'q_goal', 'q11', 'q5', 'q6', 'q15'];

/** 質問リストを取得（CATEGORY_A 固定） */
function getVisibleQuestions() {
  let questions = QUESTIONS.filter(q => CATEGORY_A_IDS.includes(q.id));
  questions.sort((a, b) => CATEGORY_A_IDS.indexOf(a.id) - CATEGORY_A_IDS.indexOf(b.id));
  state.totalQuestions = questions.length;
  state.skipQ15 = false;
  return questions;
}

/** 現在の質問オブジェクトを取得 */
function getCurrentQuestion() {
  return getVisibleQuestions()[state.currentQuestion];
}

/** プログレスバーを更新 */
function updateProgress() {
  const questions = getVisibleQuestions();
  const total = questions.length;
  const current = state.currentQuestion + 1;
  const pct = (current / total) * 100;

  const progressFillEl = document.getElementById('progress-fill');
  if (progressFillEl) {
    // 3 方法すべてで設定: inline style.width (priority important) + CSS variable + 直接 attr
    progressFillEl.style.setProperty('width', pct + '%', 'important');
    progressFillEl.style.setProperty('--progress', pct + '%');
    progressFillEl.setAttribute('style', 'width: ' + pct + '% !important; height: 100%; background: #FB4C15; border-radius: 9999px; transition: width 300ms ease-in-out;');
  } else {
    console.warn('[updateProgress] progress-fill element not found');
  }
  document.getElementById('progress-text').textContent = 'Q' + current + ' / ' + total;

  // STEP 表示（食生活チェック削除後は常にプラン診断）
  const totalSteps = 5;
  const currentStep = Math.min(state.currentQuestion + 1, totalSteps);
  document.getElementById('step-indicator').textContent = 'STEP ' + currentStep + ' / ' + totalSteps;

  const backBtn = document.getElementById('btn-back');
  if (state.currentQuestion === 0) {
    backBtn.classList.add('hidden');
  } else {
    backBtn.classList.remove('hidden');
  }

  const nextBtn = document.getElementById('btn-next');
  // 矢印は SVG icon 化（FAM DS）
  const arrowSvg = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  if (state.currentQuestion === questions.length - 1) {
    nextBtn.innerHTML = '診断結果を見る ' + arrowSvg;
  } else {
    nextBtn.innerHTML = '次へ進む ' + arrowSvg;
  }
}

/** 「次へ進む」ボタンの有効/無効を更新 */
function updateNextButton() {
  const btn = document.getElementById('btn-next');
  const q = getCurrentQuestion();
  let valid = false;

  switch (q.type) {
    case 'card-single':
    case 'list-single':
    case 'scale':
      valid = !!state.answers[q.id];
      break;
    case 'gender-age':
      valid = !!state.answers.q2_gender && !!state.answers.q2_age;
      break;
    case 'weight-select':
      valid = state.answers.q3_weight != null && !!state.answers.q3_feel;
      break;
    case 'fullcourse':
    case 'grid-multi':
      valid = true;
      break;
    case 'list-single-conditional':
      valid = !!state.answers[q.id];
      if (state.answers[q.id] === q.conditionalTrigger) {
        valid = valid && !!state.answers[q.id + '_sub'];
      }
      break;
    case 'dual-list':
      valid = q.sections.every(s => !!state.answers[q.id + '_' + s.key]);
      break;
  }

  btn.classList.toggle('disabled', !valid);
  btn.classList.toggle('enabled', valid);
}

/* ========================================
   質問描画関数（タイプ別）
   ======================================== */

function renderQuestion(direction) {
  const container = document.getElementById('quiz-content');
  const q = getCurrentQuestion();

  const animClass = direction === 'forward' ? 'slide-in-right' : 'slide-in-left';

  let html = '';

  if (state.currentQuestion === 0) {
    const catIntro = state.currentCategory === 'A'
      ? { label: 'PLAN DIAGNOSIS', heading: 'プラン診断', desc: 'あなたの体格・目標に合った食事プランを診断します。' }
      : { label: 'FOOD HABITS CHECK', heading: '食生活チェック', desc: '普段の食生活を振り返り、改善ポイントを見つけましょう。' };

    html += '<div class="quiz__step-intro">'
      + '<p class="quiz__step-intro-label">' + catIntro.label + '</p>'
      + '<h3>' + catIntro.heading + '</h3>'
      + '<p>' + catIntro.desc + '</p></div>';
  }

  html += '<div class="quiz__question ' + animClass + '">';
  html += '<h2 class="quiz__question-title">' + q.title + '</h2>';
  if (q.sub) html += '<p class="quiz__question-sub">' + q.sub + '</p>';

  switch (q.type) {
    case 'card-single': html += renderCardSingle(q); break;
    case 'gender-age': html += renderGenderAge(q); break;
    case 'weight-select': html += renderWeightSelect(q); break;
    case 'list-single': html += renderListSingle(q); break;
    case 'fullcourse': html += renderFullcourse(q); break;
    case 'list-single-conditional': html += renderListConditional(q); break;
    case 'dual-list': html += renderDualList(q); break;
    case 'grid-multi': html += renderGridMulti(q); break;
    case 'scale': html += renderScale(q); break;
  }

  html += '</div>';
  container.innerHTML = html;

  bindQuestionEvents(q);
  updateProgress();
  updateNextButton();

  // direction が 'forward' / 'back' の場合のみスクロール
  // Q11 等のマルチセレクト内部更新 (direction=null) では画面位置を維持
  if (direction === 'forward' || direction === 'back') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

/* --- カード型シングルセレクト --- */
function renderCardSingle(q) {
  const selected = state.answers[q.id] || '';
  const mod = q.cssModifier || '';
  let h = '<div class="quiz__cards ' + mod + '">';
  q.options.forEach(opt => {
    const sel = selected === opt.value ? 'selected' : '';
    h += '<div class="quiz__card ' + sel + '" data-value="' + opt.value + '">'
      + '<div class="quiz__card-icon">' + opt.icon + '</div>'
      + '<div class="quiz__card-text">'
      + '<div class="quiz__card-label">' + opt.label + '</div>'
      + (opt.desc ? '<div class="quiz__card-desc">' + opt.desc + '</div>' : '')
      + '</div>'
      + '<div class="quiz__card-check">\u2713</div>'
      + '</div>';
  });
  h += '</div>';
  return h;
}

/* --- 性別・年代 --- */
function renderGenderAge(q) {
  const selGender = state.answers.q2_gender || '';
  const selAge = state.answers.q2_age || '';

  let h = '<p class="quiz__section-label">\u6027\u5225\u3092\u9078\u3093\u3067\u304F\u3060\u3055\u3044</p>';
  h += '<div class="quiz__gender-cards">';
  q.genderOptions.forEach(opt => {
    const sel = selGender === opt.value ? 'selected' : '';
    h += '<div class="quiz__gender-card ' + sel + '" data-value="' + opt.value + '">'
      + '<div class="quiz__gender-icon">' + opt.icon + '</div>'
      + '<div class="quiz__gender-label">' + opt.label + '</div>'
      + '</div>';
  });
  h += '</div>';

  h += '<div class="quiz__age-section ' + (selGender ? 'visible' : '') + '" id="age-section">';
  h += '<p class="quiz__section-label">\u5E74\u4EE3\u3092\u9078\u3093\u3067\u304F\u3060\u3055\u3044</p>';
  h += '<div class="quiz__list">';
  q.ageOptions.forEach(opt => {
    const sel = selAge === opt.value ? 'selected' : '';
    h += '<div class="quiz__list-item ' + sel + '" data-value="' + opt.value + '" data-key="age">'
      + '<div class="quiz__radio"><div class="quiz__radio-dot"></div></div>'
      + '<div class="quiz__list-label">' + opt.label + '</div>'
      + '</div>';
  });
  h += '</div></div>';
  return h;
}

/* --- 体重 + セレクト --- */
function renderWeightSelect(q) {
  const weight = state.answers.q3_weight || q.weightDefault;
  const feel = state.answers.q3_feel || '';

  let h = '<div class="quiz__slider-section">';
  h += '<p class="quiz__section-label">\u73FE\u5728\u306E\u4F53\u91CD\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044</p>';
  h += '<div class="quiz__slider-value"><span id="weight-display">' + weight + '</span><span>kg</span></div>';
  h += '<div class="quiz__slider-wrapper">';
  h += '<button class="quiz__slider-btn" data-dir="-1" aria-label="減らす"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
  h += '<input type="range" class="quiz__slider" id="weight-slider" min="' + q.weightMin + '" max="' + q.weightMax + '" value="' + weight + '" step="1" inputmode="numeric">';
  h += '<button class="quiz__slider-btn" data-dir="1" aria-label="増やす"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="8" y1="3" x2="8" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
  h += '</div>';
  h += '<div class="quiz__slider-range"><span>' + q.weightMin + 'kg</span><span>' + q.weightMax + 'kg</span></div>';
  h += '</div>';

  h += '<p class="quiz__section-label">' + q.weightFeelLabel + '</p>';
  h += '<div class="quiz__list">';
  q.weightFeelOptions.forEach(opt => {
    const sel = feel === opt.value ? 'selected' : '';
    h += '<div class="quiz__list-item ' + sel + '" data-value="' + opt.value + '" data-key="feel">'
      + '<div class="quiz__radio"><div class="quiz__radio-dot"></div></div>'
      + '<div class="quiz__list-label">' + opt.label + '</div>'
      + '</div>';
  });
  h += '</div>';
  return h;
}

/* --- リスト型シングルセレクト --- */
function renderListSingle(q) {
  const selected = state.answers[q.id] || '';
  let h = '<div class="quiz__list">';
  q.options.forEach(opt => {
    const sel = selected === opt.value ? 'selected' : '';
    h += '<div class="quiz__list-item ' + sel + '" data-value="' + opt.value + '">'
      + '<div class="quiz__radio"><div class="quiz__radio-dot"></div></div>'
      + '<div><div class="quiz__list-label">' + opt.label + '</div>'
      + (opt.sub ? '<div class="quiz__list-sub">' + opt.sub + '</div>' : '')
      + '</div></div>';
  });
  h += '</div>';
  return h;
}

/* --- 栄養フルコース5要素 --- */
function renderFullcourse(q) {
  const selected = state.answers.q7 || [];
  let h = '<div class="quiz__fullcourse-cards">';
  q.options.forEach((opt, i) => {
    const sel = selected.includes(opt.value) ? 'selected' : '';
    h += '<div class="quiz__fullcourse-card ' + sel + '" data-value="' + opt.value + '">'
      + '<div class="quiz__fullcourse-icon">' + opt.icon + '</div>'
      + '<div class="quiz__fullcourse-text">'
      + '<div class="quiz__fullcourse-num">\u2460\u2461\u2462\u2463\u2464'[i] + '</div>'
      + '<div class="quiz__fullcourse-label">' + opt.label + '</div>'
      + '<div class="quiz__fullcourse-label" style="font-weight:400;font-size:13px;color:#666">' + opt.desc + '</div>'
      + '<div class="quiz__fullcourse-example">' + opt.example + '</div>'
      + '</div>'
      + '<div class="quiz__fullcourse-checkbox">' + (sel ? '\u2713' : '') + '</div>'
      + '</div>';
  });
  h += '</div>';
  h += '<p class="quiz__fullcourse-counter">5\u9805\u76EE\u4E2D <strong>' + selected.length + '</strong>\u9805\u76EE\u3092\u9078\u629E\u4E2D</p>';
  h += '<p class="quiz__fullcourse-note">\u203B \u5F53\u3066\u306F\u307E\u308B\u3082\u306E\u304C\u306A\u3044\u5834\u5408\u306F\u305D\u306E\u307E\u307E\u6B21\u3078\u304A\u9032\u307F\u304F\u3060\u3055\u3044</p>';
  return h;
}

/* --- リスト型 + 条件分岐（Q8） --- */
function renderListConditional(q) {
  const selected = state.answers[q.id] || '';
  const subSel = state.answers[q.id + '_sub'] || '';
  const showCond = selected === q.conditionalTrigger;

  let h = '<div class="quiz__list">';
  q.options.forEach(opt => {
    const sel = selected === opt.value ? 'selected' : '';
    h += '<div class="quiz__list-item ' + sel + '" data-value="' + opt.value + '">'
      + '<div class="quiz__radio"><div class="quiz__radio-dot"></div></div>'
      + '<div class="quiz__list-label">' + opt.label + '</div>'
      + '</div>';
  });
  h += '</div>';

  h += '<div class="quiz__conditional ' + (showCond ? 'visible' : '') + '" id="conditional-area">';
  h += '<div class="quiz__conditional-inner">';
  h += '<p class="quiz__conditional-label">' + q.conditionalLabel + '</p>';
  h += '<div class="quiz__gender-cards">';
  q.conditionalOptions.forEach(opt => {
    const sel = subSel === opt.value ? 'selected' : '';
    h += '<div class="quiz__gender-card ' + sel + '" data-value="' + opt.value + '" data-key="sub">'
      + '<div class="quiz__gender-label">' + opt.label + '</div>'
      + '</div>';
  });
  h += '</div></div></div>';
  return h;
}

/* --- 2段階リスト（Q9） --- */
function renderDualList(q) {
  let h = '';
  q.sections.forEach((sec, idx) => {
    const selected = state.answers[q.id + '_' + sec.key] || '';
    const showClass = idx === 0 || state.answers[q.id + '_' + q.sections[0].key] ? 'visible' : '';

    if (idx > 0) {
      h += '<div class="quiz__age-section ' + showClass + '" id="dual-section-' + idx + '">';
    }
    h += '<p class="quiz__section-label">' + sec.label + '</p>';
    h += '<div class="quiz__list">';
    sec.options.forEach(opt => {
      const sel = selected === opt.value ? 'selected' : '';
      h += '<div class="quiz__list-item ' + sel + '" data-value="' + opt.value + '" data-key="' + sec.key + '">'
        + '<div class="quiz__radio"><div class="quiz__radio-dot"></div></div>'
        + '<div class="quiz__list-label">' + opt.label + '</div>'
        + '</div>';
    });
    h += '</div>';
    if (idx > 0) h += '</div>';
  });
  return h;
}

/* --- グリッド型マルチセレクト（Q11） --- */
function renderGridMulti(q) {
  const selected = state.answers[q.id] || [];
  const maxed = selected.length >= q.maxSelect;

  let h = '<div class="quiz__grid-cards">';
  q.options.forEach(opt => {
    const sel = selected.includes(opt.value) ? 'selected' : '';
    const dis = !sel && maxed ? 'disabled' : '';
    h += '<div class="quiz__grid-card ' + sel + ' ' + dis + '" data-value="' + opt.value + '">'
      + '<div class="quiz__grid-card-icon">' + opt.icon + '</div>'
      + '<div class="quiz__grid-card-label">' + opt.label + '</div>'
      + '</div>';
  });
  if (q.noneOption) {
    const nSel = selected.includes(q.noneOption.value) ? 'selected' : '';
    h += '<div class="quiz__grid-none"><div class="quiz__grid-card ' + nSel + '" data-value="' + q.noneOption.value + '" data-none="true">'
      + '<div class="quiz__grid-card-icon">' + q.noneOption.icon + '</div>'
      + '<div class="quiz__grid-card-label">' + q.noneOption.label + '</div>'
      + '</div></div>';
  }
  h += '</div>';
  h += '<p class="quiz__grid-counter">3\u3064\u307E\u3067\u9078\u629E\u3067\u304D\u307E\u3059\uFF08\u6B8B\u308A <strong>' + (q.maxSelect - selected.length) + '</strong>\u3064\uFF09</p>';
  return h;
}

/* --- 5段階スケール --- */
function renderScale(q) {
  const selected = state.answers[q.id] || '';
  let h = '<div class="quiz__scale">';
  q.options.forEach(opt => {
    const sel = selected === opt.value ? 'selected' : '';
    h += '<div class="quiz__scale-item ' + sel + '" data-value="' + opt.value + '">'
      + '<span class="quiz__scale-icon">' + opt.icon + '</span>'
      + '<span class="quiz__scale-label">' + opt.label + '</span>'
      + '<div class="quiz__scale-bar"></div>'
      + '</div>';
  });
  h += '</div>';
  return h;
}

/* ========================================
   イベントバインディング
   ======================================== */
function bindQuestionEvents(q) {
  switch (q.type) {
    case 'card-single':
      document.querySelectorAll('.quiz__card').forEach(card => {
        card.addEventListener('click', () => {
          document.querySelectorAll('.quiz__card').forEach(c => c.classList.remove('selected'));
          card.classList.add('selected');
          state.answers[q.id] = card.dataset.value;
          updateNextButton();
        });
      });
      break;

    case 'gender-age':
      document.querySelectorAll('.quiz__gender-card:not([data-key])').forEach(card => {
        card.addEventListener('click', () => {
          document.querySelectorAll('.quiz__gender-card:not([data-key])').forEach(c => c.classList.remove('selected'));
          card.classList.add('selected');
          state.answers.q2_gender = card.dataset.value;
          document.getElementById('age-section').classList.add('visible');
          updateNextButton();
        });
      });
      document.querySelectorAll('[data-key="age"]').forEach(item => {
        item.addEventListener('click', () => {
          document.querySelectorAll('[data-key="age"]').forEach(i => i.classList.remove('selected'));
          item.classList.add('selected');
          state.answers.q2_age = item.dataset.value;
          updateNextButton();
        });
      });
      break;

    case 'weight-select': {
      const slider = document.getElementById('weight-slider');
      const display = document.getElementById('weight-display');
      if (state.answers.q3_weight == null) state.answers.q3_weight = q.weightDefault;

      const updateSlider = () => {
        display.textContent = slider.value;
        state.answers.q3_weight = parseInt(slider.value);
        const pct = ((slider.value - q.weightMin) / (q.weightMax - q.weightMin)) * 100;
        slider.style.background = 'linear-gradient(to right, #1B1D1A 0%, #1B1D1A ' + pct + '%, #E8E8E3 ' + pct + '%, #E8E8E3 100%)';
        updateNextButton();
      };
      slider.addEventListener('input', updateSlider);
      updateSlider();

      document.querySelectorAll('.quiz__slider-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const dir = parseInt(btn.dataset.dir);
          slider.value = Math.min(q.weightMax, Math.max(q.weightMin, parseInt(slider.value) + dir));
          updateSlider();
        });
      });

      document.querySelectorAll('[data-key="feel"]').forEach(item => {
        item.addEventListener('click', () => {
          document.querySelectorAll('[data-key="feel"]').forEach(i => i.classList.remove('selected'));
          item.classList.add('selected');
          state.answers.q3_feel = item.dataset.value;
          updateNextButton();
        });
      });
      break;
    }

    case 'list-single':
      document.querySelectorAll('.quiz__list-item').forEach(item => {
        item.addEventListener('click', () => {
          document.querySelectorAll('.quiz__list-item').forEach(i => i.classList.remove('selected'));
          item.classList.add('selected');
          state.answers[q.id] = item.dataset.value;
          updateNextButton();
        });
      });
      break;

    case 'fullcourse':
      if (!state.answers.q7) state.answers.q7 = [];
      document.querySelectorAll('.quiz__fullcourse-card').forEach(card => {
        card.addEventListener('click', () => {
          const val = card.dataset.value;
          const arr = state.answers.q7;
          const idx = arr.indexOf(val);
          if (idx >= 0) {
            arr.splice(idx, 1);
            card.classList.remove('selected');
            card.querySelector('.quiz__fullcourse-checkbox').textContent = '';
          } else {
            arr.push(val);
            card.classList.add('selected');
            card.querySelector('.quiz__fullcourse-checkbox').textContent = '\u2713';
          }
          const counter = document.querySelector('.quiz__fullcourse-counter');
          if (counter) counter.innerHTML = '5\u9805\u76EE\u4E2D <strong>' + arr.length + '</strong>\u9805\u76EE\u3092\u9078\u629E\u4E2D';
          updateNextButton();
        });
      });
      break;

    case 'list-single-conditional':
      document.querySelectorAll('.quiz__list-item').forEach(item => {
        item.addEventListener('click', () => {
          document.querySelectorAll('.quiz__list-item').forEach(i => i.classList.remove('selected'));
          item.classList.add('selected');
          state.answers[q.id] = item.dataset.value;
          const condArea = document.getElementById('conditional-area');
          if (item.dataset.value === q.conditionalTrigger) {
            condArea.classList.add('visible');
          } else {
            condArea.classList.remove('visible');
            delete state.answers[q.id + '_sub'];
          }
          updateNextButton();
        });
      });
      document.querySelectorAll('[data-key="sub"]').forEach(card => {
        card.addEventListener('click', () => {
          document.querySelectorAll('[data-key="sub"]').forEach(c => c.classList.remove('selected'));
          card.classList.add('selected');
          state.answers[q.id + '_sub'] = card.dataset.value;
          updateNextButton();
        });
      });
      break;

    case 'dual-list':
      q.sections.forEach((sec, idx) => {
        document.querySelectorAll('[data-key="' + sec.key + '"]').forEach(item => {
          item.addEventListener('click', () => {
            document.querySelectorAll('[data-key="' + sec.key + '"]').forEach(i => i.classList.remove('selected'));
            item.classList.add('selected');
            state.answers[q.id + '_' + sec.key] = item.dataset.value;
            if (idx < q.sections.length - 1) {
              const next = document.getElementById('dual-section-' + (idx + 1));
              if (next) next.classList.add('visible');
            }
            updateNextButton();
          });
        });
      });
      break;

    case 'grid-multi':
      if (!state.answers[q.id]) state.answers[q.id] = [];
      document.querySelectorAll('.quiz__grid-card').forEach(card => {
        card.addEventListener('click', () => {
          if (card.classList.contains('disabled')) return;
          const val = card.dataset.value;
          const isNone = card.dataset.none === 'true';
          const arr = state.answers[q.id];

          if (isNone) {
            state.answers[q.id] = arr.includes(val) ? [] : [val];
          } else {
            const noneIdx = arr.indexOf(q.noneOption.value);
            if (noneIdx >= 0) arr.splice(noneIdx, 1);
            const idx = arr.indexOf(val);
            if (idx >= 0) {
              arr.splice(idx, 1);
            } else if (arr.length < q.maxSelect) {
              arr.push(val);
            }
          }
          renderQuestion(null);
        });
      });
      break;

    case 'scale':
      document.querySelectorAll('.quiz__scale-item').forEach(item => {
        item.addEventListener('click', () => {
          document.querySelectorAll('.quiz__scale-item').forEach(i => i.classList.remove('selected'));
          item.classList.add('selected');
          state.answers[q.id] = item.dataset.value;
          updateNextButton();
        });
      });
      break;
  }
}

/* ========================================
   画面遷移制御
   ======================================== */
function showScreen(screenId) {
  document.querySelectorAll('.screen').forEach(s => {
    s.classList.remove('active', 'fade-in');
  });
  const target = document.getElementById(screenId);
  target.classList.add('active', 'fade-in');
  window.scrollTo({ top: 0, behavior: 'auto' });
}

function startDiagnosis() {
  // 食生活チェック削除に伴い、Select画面はスキップして直接 Quiz へ
  state.mode = 'planA';
  state.currentQuestion = 0;
  state.currentCategory = 'A';
  state.categoryADone = false;
  showScreen('screen-quiz');
  renderQuestion('forward');
}

function startCategory(mode) {
  // 旧Selectからの遷移: planA固定として処理
  state.mode = 'planA';
  state.currentQuestion = 0;
  state.currentCategory = 'A';
  state.categoryADone = false;
  showScreen('screen-quiz');
  renderQuestion('forward');
}

function goNext() {
  const visibleQs = getVisibleQuestions();
  if (state.currentQuestion >= visibleQs.length - 1) {
    showScreen('screen-loading');
    runLoadingAnimation();
    return;
  }
  state.currentQuestion++;
  renderQuestion('forward');
}

function goBack() {
  if (state.currentQuestion <= 0) return;
  state.currentQuestion--;
  renderQuestion('backward');
}

/* ========================================
   ローディング画面 (FAM DS v0.3 progress-step 連動)
   ======================================== */
function runLoadingAnimation() {
  buildLoadingSummary();

  const steps = document.querySelectorAll('#loading-steps .progress-step');
  if (!steps.length) {
    // フェイルセーフ: ステップ要素がない場合は即座に結果へ
    setTimeout(() => {
      const result = calculateResult();
      renderResult(result);
      showScreen('screen-result');
    }, 1500);
    return;
  }

  let currentStep = 0;
  const interval = setInterval(() => {
    setLoadingStepActive(currentStep);
    currentStep++;
    if (currentStep > steps.length) {
      clearInterval(interval);
      setTimeout(() => {
        // 全ステップ完了表示
        steps.forEach(el => {
          el.classList.remove('is-active');
          el.classList.add('is-done');
          const en = el.querySelector('.progress-step__check-en');
          if (en) en.textContent = 'DONE';
        });
        setTimeout(() => {
          const result = calculateResult();
          renderResult(result);
          showScreen('screen-result');
        }, 600);
      }, 500);
    }
  }, 700);
}


/* ========================================
   Loading画面: 入力サマリー + Step進行
   FAM DS v0.3 対応 (2026-05-08)
   ======================================== */
function buildLoadingSummary() {
  const itemsContainer = document.querySelector('#loading-summary .loading-summary__items');
  if (!itemsContainer) return;

  const weight = state.answers.q3_weight || 65;
  const goal = state.answers.q_goal;
  const gender = state.answers.q2_gender;
  const age = state.answers.q2_age;
  const activity = state.answers.q5;

  const goalLabels = {
    muscle_gain: '筋肉量増加',
    bulk_up: '体を大きく',
    lean_down: '減量・除脂肪',
    maintain: 'コンディション維持'
  };
  const genderLabels = { male: '男性', female: '女性' };
  const activityLabels = {
    pro: 'プロ', club: '競技者', amateur_compete: '競技志向',
    casual: '一般', none: '健康維持'
  };

  const chips = [];
  if (gender) {
    let chipHtml = '<strong>' + (genderLabels[gender] || '') + '</strong>';
    if (age) chipHtml += ' / ' + age + '歳';
    chips.push(chipHtml);
  }
  if (weight) chips.push('<strong>' + weight + 'kg</strong>');
  if (goal) chips.push('目標: <strong>' + (goalLabels[goal] || goal) + '</strong>');
  if (activity) chips.push('活動: <strong>' + (activityLabels[activity] || activity) + '</strong>');

  itemsContainer.innerHTML = chips.map(html =>
    '<span class="loading-summary__chip">' + html + '</span>'
  ).join('');
}

/** Loading のステップ進行制御 (FAM DS progress-step) */
function setLoadingStepActive(index) {
  const steps = document.querySelectorAll('#loading-steps .progress-step');
  steps.forEach((el, i) => {
    el.classList.remove('is-active', 'is-done');
    const en = el.querySelector('.progress-step__check-en');
    if (en) en.textContent = 'PENDING';
    if (i < index) {
      el.classList.add('is-done');
      if (en) en.textContent = 'DONE';
    } else if (i === index) {
      el.classList.add('is-active');
      if (en) en.textContent = 'RUNNING';
    }
  });
}

/* ========================================
   結果画面の描画 (FAM DS v0.3)
   ======================================== */

/** goalKey → 大型タイプ英字 マッピング */
function getTypeEnLabel(goalKey) {
  const map = {
    muscle_gain: 'POWER',
    athlete_standard: 'SPEED',
    health_maintain: 'ENDURANCE',
    lean_support: 'ENDURANCE',
    general_healthcare: 'CONDITIONING'
  };
  return map[goalKey] || 'POWER';
}

/** goalKey → body data-type マッピング */
function getBodyTypeAttr(goalKey) {
  const map = {
    muscle_gain: 'power',
    athlete_standard: 'speed',
    health_maintain: 'endurance',
    lean_support: 'endurance',
    general_healthcare: 'conditioning'
  };
  return map[goalKey] || 'power';
}

/** planKey → assets/plan-{slug}.jpg のスラッグ */
function getPlanImageSlug(planKey) {
  const map = {
    athleteplus60: 'athlete-plus-60',
    athletesupport50: 'athlete-support-50',
    physical40: 'physical-40',
    healthcare30: 'healthcare-30'
  };
  return map[planKey] || 'athlete-plus-60';
}

function renderResult(data) {
  const goalKey = data.goalKey;
  const typeAttr = getBodyTypeAttr(goalKey);
  const weight = state.answers.q3_weight || data.refWeight;

  // body 全体に data-type 反映 (CSS のタイプ色連動)
  document.body.dataset.type = typeAttr;

  // 大型タイプ英字
  const typeEnEl = document.getElementById('type-en');
  if (typeEnEl) typeEnEl.textContent = getTypeEnLabel(goalKey);

  // リードタイトル + リード本文
  const leadTitle = document.getElementById('lead-title');
  if (leadTitle) leadTitle.innerHTML = data.goalName + '<br>' + data.patternName;
  const leadBody = document.getElementById('lead-body');
  if (leadBody) leadBody.textContent = getShopifyTypeCatchcopy(goalKey) || data.catchcopy;

  // アスリート画像 swap
  const athleteImg = document.getElementById('athlete-img');
  if (athleteImg) {
    athleteImg.src = getShopifyAssetUrl('athlete', typeAttr) || ('assets/athlete-' + typeAttr + '.svg');
    athleteImg.alt = getTypeEnLabel(goalKey) + ' TYPE のアスリート';
  }

  // Stat Cards (Hero 右下)
  const statKcal = document.getElementById('stat-kcal');
  if (statKcal) statKcal.textContent = data.kcal.toLocaleString();
  const statProtein = document.getElementById('stat-protein');
  if (statProtein) statProtein.textContent = data.pGrams;
  const statKcalSub = document.getElementById('stat-kcal-sub');
  if (statKcalSub) statKcalSub.textContent = weight + 'kgに最適化';
  const statProteinSub = document.getElementById('stat-protein-sub');
  if (statProteinSub) {
    const ratio = (data.pGrams / weight).toFixed(1);
    statProteinSub.textContent = '体重×' + ratio + 'g';
  }

  // 各セクション描画
  renderPFCResult(data);
  renderTips(data);
  renderMealModel(data);
  renderPlanSection(data);
}

/* 旧フォーマット互換: prepareResultSections / renderConditioningAdvice / renderWeightGoalAdvice / renderResultB / renderFullcourseResult / renderFoodHabitsAdvice / renderExtraAdvice / setupScrollAnimations は no-op (新HTMLに該当要素なし) */
function prepareResultSections() { /* no-op v0.3 */ }
function renderConditioningAdvice() { /* no-op v0.3 (新HTMLに該当要素なし) */ }
function renderWeightGoalAdvice() { /* no-op v0.3 */ }
function renderResultB() { /* no-op v0.3 (mode=planA固定) */ }
function renderFoodHabitsAdvice() { /* no-op v0.3 (食生活チェック削除) */ }
function renderFullcourseResult() { /* no-op v0.3 (栄養フルコース削除) */ }
function renderExtraAdvice() { /* no-op v0.3 */ }
function setupScrollAnimations() { /* no-op v0.3 */ }

/** PFC バランス: ドーナツ + 3カラム + スタックバー */
const PFC_COLORS = {
  protein: '#FB4C15',  // Drive Orange (Sequential 1)
  fat:     '#FB8817',  // Drive Fat (Sequential 2)
  carb:    '#1B1D1A'   // Ink (Sequential 3)
};

function renderPFCResult(data) {
  const pfc = data.pfc;
  const kcal = data.kcal;
  // p%, f%, c% は範囲の中央値を使用
  const pPct = Math.round((pfc.p[0] + pfc.p[1]) / 2);
  const fPct = Math.round((pfc.f[0] + pfc.f[1]) / 2);
  const cPct = 100 - pPct - fPct;

  // g 換算
  const pG = Math.round(kcal * pPct / 100 / 4);
  const fG = Math.round(kcal * fPct / 100 / 9);
  const cG = Math.round(kcal * cPct / 100 / 4);

  // ドーナツ中央 kcal
  const pfcKcal = document.getElementById('pfc-kcal');
  if (pfcKcal) pfcKcal.textContent = kcal.toLocaleString();

  // 3カラムの値
  const setText = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
  setText('pfc-p-g', pG);   setText('pfc-p-pct', pPct);
  setText('pfc-f-g', fG);   setText('pfc-f-pct', fPct);
  setText('pfc-c-g', cG);   setText('pfc-c-pct', cPct);

  // スタックバー
  const stackbar = document.getElementById('pfc-stackbar');
  if (stackbar) {
    stackbar.innerHTML =
      '<div class="pfc-stackbar__seg protein" style="width: ' + pPct + '%">' + pPct + '%</div>' +
      '<div class="pfc-stackbar__seg fat" style="width: ' + fPct + '%">' + fPct + '%</div>' +
      '<div class="pfc-stackbar__seg carb" style="width: ' + cPct + '%">' + cPct + '%</div>';
  }

  // Chart.js ドーナツ (canvas が存在する場合のみ)
  renderPFCChart(pPct, fPct, cPct);
}

function renderPFCChart(pPct, fPct, cPct) {
  const canvas = document.getElementById('pfc-chart');
  if (!canvas || typeof Chart === 'undefined') return;
  if (state.pfcChart) state.pfcChart.destroy();
  const ctx = canvas.getContext('2d');
  state.pfcChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels: ['たんぱく質', '脂質', '炭水化物'],
      datasets: [{
        data: [pPct, fPct, cPct],
        backgroundColor: [PFC_COLORS.protein, PFC_COLORS.fat, PFC_COLORS.carb],
        borderWidth: 0,
        cutout: '70%'
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: { legend: { display: false }, tooltip: { enabled: false } },
      animation: { animateRotate: true, duration: 800 }
    }
  });
}

/** 食事改善 3つのポイント */
function renderTips(data) {
  const container = document.getElementById('result-tip-cards');
  if (!container) return;
  const tips = (data.tips || []).slice(0, 3);
  container.innerHTML = tips.map((tip, i) =>
    '<article class="tip-card">' +
      '<p class="tip-card__num">' + String(i + 1).padStart(2, '0') + '</p>' +
      '<h3 class="tip-card__title">' + tip.title + '</h3>' +
      '<p class="tip-card__desc">' + tip.text + '</p>' +
    '</article>'
  ).join('');
}

/** 1日の食事モデル: 左右2カラム (PC) / 1列連続 (SP) */
function renderMealModel(data) {
  const wrap = document.getElementById('result-meal-timeline');
  if (!wrap) return;
  const meals = data.meals || [];
  const half = Math.ceil(meals.length / 2);
  const morning = meals.slice(0, half);
  const evening = meals.slice(half);

  const renderTimelineItem = (m) => {
    const time = (m.time || '').toUpperCase();
    return '<div class="timeline-item">' +
      '<p class="timeline-item__time">' + time + '</p>' +
      '<p class="timeline-item__title">' + (m.time || '') + (m.fambox ? ' (FAM BOX)' : '') + '</p>' +
      '<p class="timeline-item__menu">' + (m.menu || '') + '</p>' +
    '</div>';
  };

  wrap.innerHTML =
    '<div class="timeline">' + morning.map(renderTimelineItem).join('') + '</div>' +
    '<div class="timeline">' + evening.map(renderTimelineItem).join('') + '</div>';
}

/** おすすめプラン */
function renderPlanSection(data) {
  const planSlug = getPlanImageSlug(data.planKey);
  const setText = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };

  // Shopify Schema 優先 → fallback hardcoded
  const planSchema = getShopifyPlanData(data.planKey);
  const planNameMap = {
    athleteplus60: 'ATHLETE PLUS 60',
    athletesupport50: 'ATHLETE SUPPORT 50',
    physical40: 'PHYSICAL 40',
    healthcare30: 'HEALTHCARE 30'
  };
  setText('plan-name-en', (planSchema && planSchema.nameEn) || planNameMap[data.planKey] || data.planName);
  setText('plan-name-ja', (planSchema && planSchema.nameJa) || data.planName);
  setText('result-plan-protein', (planSchema && planSchema.protein) || data.planProtein);
  setText('result-plan-desc', (planSchema && planSchema.desc) || data.goalDesc || data.catchcopy);

  // プランイメージ画像
  const planImg = document.getElementById('plan-image');
  if (planImg) {
    planImg.src = getShopifyAssetUrl('plan', data.planKey) || ('assets/plan-' + planSlug + '.jpg');
    planImg.alt = (planNameMap[data.planKey] || data.planName) + ' のプランイメージ';
  }

  // CTA リンク (プラン詳細ページへ)
  const cta = document.getElementById('result-plan-cta');
  if (cta) cta.href = (planSchema && planSchema.url) || ('/products/' + planSlug);
}
function shareResult() {
  const result = calculateResult();
  const shareData = {
    title: 'FAM BOX \u98DF\u4E8B\u8A3A\u65AD\u7D50\u679C',
    text: 'FAM BOX\u306E\u98DF\u4E8B\u8A3A\u65AD\u3067\u3010' + result.goalName + '\u3011\u3068\u8A3A\u65AD\u3055\u308C\u307E\u3057\u305F\uFF01\u3042\u306A\u305F\u306E\u6804\u990A\u30BF\u30A4\u30D7\u306F\uFF1F',
    url: window.location.href
  };
  if (navigator.share) {
    navigator.share(shareData).catch(() => {});
  } else {
    navigator.clipboard.writeText(shareData.text + '\n' + shareData.url).then(() => {
      alert('\u7D50\u679C\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\uFF01');
    }).catch(() => {});
  }
}

/* ========================================
   リセット
   ======================================== */
function resetDiagnosis() {
  state.currentQuestion = 0;
  state.answers = {};
  state.skipQ15 = false;
  state.totalQuestions = 8;
  state.mode = 'planA';
  state.currentCategory = 'A';
  state.categoryADone = false;
  if (state.pfcChart) { state.pfcChart.destroy(); state.pfcChart = null; }

  // FAM DS v0.3: progress-step リセット
  document.querySelectorAll('#loading-steps .progress-step').forEach(step => {
    step.classList.remove('is-active', 'is-done');
    const en = step.querySelector('.progress-step__check-en');
    if (en) en.textContent = 'PENDING';
  });

  // body data-type リセット
  document.body.dataset.type = '';

  showScreen('screen-intro');
}

/* ========================================
   初期化 (FAM DS v0.3)
   ======================================== */
document.addEventListener('DOMContentLoaded', () => {
  // 開始ボタン (Hero CTA)
  const btnStart = document.getElementById('btn-start');
  if (btnStart) btnStart.addEventListener('click', startDiagnosis);

  // 開始ボタン (Bottom CTA)
  const btnStartBottom = document.getElementById('btn-start-bottom');
  if (btnStartBottom) btnStartBottom.addEventListener('click', startDiagnosis);

  // Quiz 操作
  const btnNext = document.getElementById('btn-next');
  if (btnNext) {
    btnNext.addEventListener('click', () => {
      if (!btnNext.classList.contains('disabled')) goNext();
    });
  }
  const btnBack = document.getElementById('btn-back');
  if (btnBack) btnBack.addEventListener('click', goBack);

  // Result 操作
  const btnRetry = document.getElementById('btn-retry');
  if (btnRetry) btnRetry.addEventListener('click', resetDiagnosis);
  const btnShare = document.getElementById('btn-share');
  if (btnShare) btnShare.addEventListener('click', shareResult);

  // 食生活チェック関連の btn-do-plan-a (旧Bモード→Aへ遷移) は削除済み
});
